import React from "react";
import { useNavigate } from "react-router-dom";
import { Avatar, Box, Button, Card, CardContent, Divider, Stack, Typography } from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useAuth } from "../../context/AuthContext";

export default function Settings() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate("/admin/login");
  }

  return (
    <Box>
      <Typography variant="h4" sx={{ mb: 3 }}>
        Settings
      </Typography>

      <Card sx={{ maxWidth: 480 }}>
        <CardContent>
          <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
            <Avatar sx={{ width: 56, height: 56, bgcolor: "primary.main", fontSize: 22 }}>
              {(user?.fullName || "A").charAt(0).toUpperCase()}
            </Avatar>
            <Box>
              <Typography variant="h6">{user?.fullName || "Admin"}</Typography>
              <Typography variant="body2" color="text.secondary">
                {user?.email}
              </Typography>
            </Box>
          </Stack>
          <Divider sx={{ my: 2 }} />
          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
            Signed in as an administrator with full access to the platform.
          </Typography>
          <Button variant="outlined" color="error" startIcon={<LogoutIcon />} onClick={handleLogout}>
            Log out
          </Button>
        </CardContent>
      </Card>
    </Box>
  );
}
